import React from "react";
import { Card, Typography, Image, Space } from "antd";
import { useLocation } from "react-router-dom";
import feedbackErrorImg from "../../assets/feedback_error.png";

const { Title, Text } = Typography;

const FeedbackErrorPage: React.FC = () => {
  const location = useLocation();
  const { title, description } = location.state || {};

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        padding: "16px",
      }}
    >
      <Card
        style={{
          width: "75%",
          maxWidth: 600,
          textAlign: "center",
          borderRadius: 16,
          padding: 24,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Space direction="vertical" size="large">
          <Image src={feedbackErrorImg} alt="Error" preview={false} width={160} />
          <Title level={4} style={{ color: "#1890ff" }}>{title || "Trang bạn đang tìm kiếm không tồn tại!"}</Title>
          <Text>{description || "Vui lòng kiểm tra lại đường dẫn."}</Text>
        </Space>
      </Card>
    </div>
  );
};

export default FeedbackErrorPage;
